import styled from "styled-components";

/** GAP: the design's 5px badge radius has no token (nearest is borderRadius.sm, 4px). */
const BADGE_RADIUS = "0.3125rem";

/** The 18px tinted square behind a column's type glyph. */
export const TypeBadge = styled.span<{ $tint: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1.125rem;
  height: 1.125rem;
  border-radius: ${BADGE_RADIUS};
  background: ${({ $tint }) => $tint};
`;

